if (window.productBottomSettings) {
  const productBottomSettings = window.productBottomSettings;
  const productJson = window.productBottomSettings.product;

  function updatevariantSKU() {
    var activeVariantSku = $('#product-select').find(":selected").attr("data-sku");
    var variantskutextelement = document.querySelector('#variant-sku')
    if (variantskutextelement) {
      variantskutextelement.innerHTML = activeVariantSku
    }
  }
  function updateNotifyMeForm(whichSKU, variantTitle) {
    if ($('#notifyMeSubmitForm').length > 0) {
      var notifyMeTags;
      if (whichSKU == null) {
        notifyMeTags = `notifyme_${encodeURIComponent(productJson.title.replaceAll('"', "'").replaceAll(", ", ""))}`;
      } else {
        notifyMeTags = "notifyme_" + whichSKU;
      }
      $('#notifyMeTags').val(notifyMeTags);
      if (variantTitle != 'Default Title') {
        $('#notifyMeSubmitForm').find('.variant-title').html(variantTitle);
      }
    }
  }

  function updateBadges() {
    var variant = document.querySelector('#product-select').value;
    var productSaleBadge = document.querySelector(".js-sale-badge")
    var productSecondaryBadge = document.querySelector(".js-secondary-badge")
    var saleBadges = window.productBadges.saleBadges.split(',')
    var secondaryBadges = window.productBadges.secondaryBadges.split(',')
    let saleBadgeValue;
    let secondaryBadgeValue;


    for (let i = 0; i < saleBadges.length; i++) {
      if (saleBadges[i].includes(variant)) {
        saleBadgeArray = saleBadges[i].split(':')
        saleBadgeValue = saleBadgeArray[1]
      }
    }
    for (let i = 0; i < secondaryBadges.length; i++) {
      if (secondaryBadges[i].includes(variant)) {
        secondaryBadgeArray = secondaryBadges[i].split(':')
        secondaryBadgeValue = secondaryBadgeArray[1]
      }
    }

    if (saleBadgeValue) {
      productSaleBadge.classList.remove('hidden')
      productSaleBadge.innerHTML = saleBadgeValue
    } else {
      productSaleBadge.classList.add('hidden')
    }
    if (secondaryBadgeValue) {
      productSecondaryBadge.classList.remove('hidden')
      productSecondaryBadge.innerHTML = secondaryBadgeValue
    } else {
      productSecondaryBadge.classList.add('hidden')
    }

  }

  function updateImages() {
    if (productJson.variants.length > 1) {
      var justActiveSlideMarkup = '';
      // needs to be accessed after owl carousel is initialised:

      var activeVariant = $('#product-select').val();

      var foundAMatch = false;
      var justImageMarkup = '';
      var count = 0;
      $('#addToCartForm').removeClass('single-image');
      $('#product-photos .item').hide().removeClass('featuredShow');

      $('#product-photos .photo-zoom.image').each(function () {
        var attr = $(this).attr('data-variant');
        if (typeof attr !== typeof undefined && attr !== false) {

          if ($(this).attr('data-variant').indexOf(activeVariant) != -1) {
            count += 1;
            foundAMatch = true;
            $(this).parents('.item').show().addClass('featuredShow');
            justActiveSlideMarkup += '<div class="item">' + $(this).html() + '</div>';
          }
        }
        justImageMarkup += '<div class="item">' + $(this).html() + '</div>';
      });

      if (count <= 2) {
        $('#addToCartForm').addClass('single-image');
      }

      if (!foundAMatch) {
        $('#product-photos .owl-item').show().addClass('featuredShow');
        //  not btn-view-gallery
        justActiveSlideMarkup = justImageMarkup;
      }
    } else {

      var count = 0;
      var justImageMarkup = '';
      $('#product-photos .photo-zoom.image').each(function (i) {
        justImageMarkup += '<div class="item">' + $(this).html() + '</div>';
        count += 1
      });
      justActiveSlideMarkup = justImageMarkup;
      count <= 2 ? $('#addToCartForm').addClass('single-image') : $('#addToCartForm').removeClass('single-image');
    }

    $('#product-photos').removeClass('working');

    // create the mobile version of this with just the active slides in:
    if (typeof $imageCarousel !== "undefined") {
      $imageCarousel.owlCarousel('destroy');
    }

    $('#imageCarousel').html(justActiveSlideMarkup);
    $imageCarousel = jQuery('.product-photos #imageCarousel').owlCarousel({
      animateOut: 'fadeOut',
      items: 1,
      stopOnHover: true,
      margin: 0,
      nav: true,
      dots: true,
      loop: true
    });


    if (jQuery('.product-photos #imageCarousel .owl-dot').length) {
      jQuery('.product-photos #imageCarousel .owl-dot').each(function (i) {
        $(this).attr('aria-label', 'Image ' + (i + 1));
      });
    }
  }

  function checkForMatchingProducts() {
    if (productBottomSettings.pdpStockTypeToggle === 'm20') {
      var activeVariant = $('#product-select').val();
      // change the 'In Stock' link:
      if (variantMatches.hasOwnProperty(activeVariant)) {
        $('#inStockSiblingLink').attr('href', variantMatches[activeVariant]);
      } else {
        $('#inStockSiblingLink').attr('href', $('#inStockSiblingLink').attr('data-default'));
      }
      //if(typeof thisFeature !== "undefined") {
      // change the feature links (eg. 'Back Height'):
      $('.custom.back-height li a').each(function () {
        var thisFeature = $(this).parent().attr('data-feature');
        if (variantFeatureMatches[thisFeature] != undefined) {
          if (variantFeatureMatches[thisFeature].hasOwnProperty(activeVariant)) {
            $(this).attr('href', variantFeatureMatches[thisFeature][activeVariant]);
          } else {
            $(this).attr('href', $(this).parent().attr('data-default'));
          }
        }
      });
      //}
    }
  }

  function resetAddons() {
    document.querySelectorAll(".c-addon__check--hide").forEach(addonSelect => {
      var checkbox = addonSelect.nextElementSibling
      var addtocartel = document.getElementById('addToCartText');
      var addonSelectedTotalEl = document.querySelector('.js-addon-selected-total')

      checkbox.classList.add('c-addon__check--show');
      checkbox.classList.remove('c-addon__check--is-checked')
      addonSelect.setAttribute("data-previous-price", 0)
      addonSelectedTotalEl.setAttribute('data-price-total', 0)
      addonSelectedTotalEl.setAttribute('data-price-total-original', 0)
      addonSelectedTotalEl.innerHTML = ''
      addonSelect.setAttribute("data-selected", "false")
      addonSelect.setAttribute("name", "")
    })
  }

  function updateAddons(currentConfigObject) {
    resetAddons()

    const addon = document.querySelector(".addon");

    if (currentConfigObject.upsell) {
      if (addon) addon.style.display = "block"

      var addonElements = document.querySelectorAll('.c-addon')

      addonElements.forEach(addonItem => {
        var parentVariantId = Number(addonItem.getAttribute('data-parent-variant'));

        if (parentVariantId == currentConfigObject.id) {
          addonItem.classList.add('c-addon--show')
          addonItem.classList.remove('c-addon--hide')
        } else if (addonItem.classList.contains('c-addon--show')) {
          addonItem.classList.add('c-addon--hide')
          addonItem.classList.remove('c-addon--show')
        }
      })
    } else if (addon) {
      addon.style.display = "none"
    }
  }

  function updatePrices(variant) {
    const elContainer = document.querySelector("#addToCartForm");
    var addtocartel = elContainer.querySelector('#addToCartText');
    var addtocartpriceStandard = addtocartel.querySelector(".product-price-js")
    var addtocartprice = addtocartpriceStandard

    var productPriceElements = elContainer.querySelectorAll(".js-price")
    var productPrice = Number(variant.price)
    var saleProducts = window.product.saleProducts.split(',')
    let productOnSale = false
    let saleValue

    for (let i = 0; i < saleProducts.length; i++) {
      if (saleProducts[i].includes(variant.id)) {
        productOnSale = true;
        saleValueArray = saleProducts[i].split(':')
        saleValue = Number(saleValueArray[1])
      }
    }

    productPriceElements.forEach(priceElement => {
      priceElement.setAttribute("data-price", productPrice)
      priceElement.setAttribute("data-addon-price", 0)
      priceElement.setAttribute("data-current-price", productPrice)
      priceElement.innerHTML = Shopify.formatMoney(productPrice, productBottomSettings.moneyFormat)
    })

    addtocartprice.innerHTML = Shopify.formatMoney(productPrice, productBottomSettings.moneyFormat)
    addtocartprice.setAttribute("data-total-price", productPrice)

    var productSalePrice = elContainer.querySelector(".js-sale-price")
    var percentElement = elContainer.querySelector(".js-price-percentage")

    if (productOnSale) {

      var percentage = Math.ceil(((productPrice - saleValue) * 100) / productPrice)

      productSalePrice.classList.remove('hidden')
      percentElement.parentElement.classList.remove('hidden')

      productSalePrice.setAttribute("data-price", saleValue)
      productSalePrice.setAttribute("data-addon-price", 0)
      productSalePrice.setAttribute("data-current-price", saleValue)
      productSalePrice.innerHTML = Shopify.formatMoney(saleValue, productBottomSettings.moneyFormat)
      percentElement.innerHTML = percentage

      addtocartprice.innerHTML = Shopify.formatMoney(saleValue, productBottomSettings.moneyFormat)
      addtocartprice.setAttribute("data-total-price", saleValue)


      productPriceElements.forEach(priceElement => {
        priceElement.classList.add('strikethrough')
      })

    } else {
      productSalePrice.classList.add('hidden')
      percentElement.parentElement.classList.add('hidden')
      productPriceElements.forEach(priceElement => {
        priceElement.classList.remove('strikethrough')
      })
    }
  }

  function checkboxChange(selectel, selected, price) {
    var checkbox = selectel.nextElementSibling

    if (selected == "false") {
      checkbox.classList.remove('c-addon__check--show');
      checkbox.classList.add('c-addon__check--is-checked')
      selectel.setAttribute("data-selected", "true")
      selectel.setAttribute("name", "addon")
      selectel.setAttribute("data-previous-price", price)
    } else {
      checkbox.classList.add('c-addon__check--show');
      checkbox.classList.remove('c-addon__check--is-checked')
      selectel.setAttribute("data-previous-price", 0)
      selectel.setAttribute("data-selected", "false")
      selectel.setAttribute("name", "")
    }
  }

  function addOnPrice(selectel, selected, price, orginalPrice) {
    var addonSelectedTotalEl = document.querySelector('.js-addon-selected-total'),
      addonSelectedTotal = addonSelectedTotalEl.getAttribute('data-price-total'),
      addonSelectedTotalOriginal = addonSelectedTotalEl.getAttribute('data-price-total-original'),
      addonTotalPrice = parseInt(addonSelectedTotal) - parseInt(price),
      formattedAddonTotalPrice = Shopify.formatMoney(addonTotalPrice, productBottomSettings.moneyFormat),
      addonTotalOriginalPrice = parseInt(addonSelectedTotalOriginal) - parseInt(orginalPrice);

    if (selected == "false") {
      addonTotalPrice = parseInt(addonSelectedTotal) + parseInt(price);
      addonTotalOriginalPrice = parseInt(addonSelectedTotalOriginal) + parseInt(orginalPrice);
    }

    formattedAddonTotalOriginalPrice = Shopify.formatMoney(addonTotalOriginalPrice, productBottomSettings.moneyFormat);
    formattedAddonTotalPrice = Shopify.formatMoney(addonTotalPrice, productBottomSettings.moneyFormat);

    addonSelectedTotalEl.setAttribute('data-price-total', addonTotalPrice);
    addonSelectedTotalEl.setAttribute('data-price-total-original', addonTotalOriginalPrice);

    var addonTotalPriceHTML = addonTotalPrice == 0 ? '' : '<span class="addon-selected-total-price"> + ' + formattedAddonTotalPrice + '</span>';
    var addonTotalOriginalPriceHTML = addonTotalOriginalPrice == addonTotalPrice ? '' : '<span class="addon-selected-total-original-price">+ ' + formattedAddonTotalOriginalPrice + '</span> ';

    addonSelectedTotalEl.innerHTML = addonTotalOriginalPriceHTML + addonTotalPriceHTML;
  }

  function addOnChecks() {
    document.querySelectorAll(".c-addon__check--hide").forEach(addonSelect => {
      addonSelect.addEventListener("click", (event) => {

        var selectel = event.target;
        var selected = selectel.getAttribute('data-selected');
        var addonItemEl = selectel.closest('.c-addon');
        var price = selectel.getAttribute('data-price');
        var salePrice = selectel.getAttribute('data-sale-price');

        var priceStrikethrough = price;

        if (salePrice != 0) {
          priceStrikethrough = price
          price = salePrice
        }

        var parentProdPriceEl = document.getElementById('product-price')

        var addtocartel = document.getElementById('addToCartText');
        var addtocartprice = addtocartel.querySelector(".product-price-js")
        var currentCartPrice = addtocartprice.getAttribute("data-total-price")

        var productOriginalPrice = document.querySelector(".js-price")
        var productSalePrice = document.querySelector('.js-sale-price')
        var prevPrice = selectel.getAttribute("data-previous-price");
        var addonPriceElements = addonItemEl.querySelectorAll('.c-addon__details--price')

        if (!productSalePrice.classList.contains('hidden')) {
          var parentProdOnSale = true;
          var productPrice = productSalePrice.getAttribute('data-price')
          var originalPrice = productOriginalPrice.getAttribute('data-price')
        } else {
          var productPrice = productOriginalPrice.getAttribute('data-price')
        }

        checkboxChange(selectel, selected, price);

        if (selected == "false") {

          addOnPrice(selectel, selected, price, priceStrikethrough);

          var totalPrice = parseInt(price) + (parseInt(currentCartPrice) - parseInt(prevPrice))
          var formattedPrice = Shopify.formatMoney(totalPrice, productBottomSettings.moneyFormat)

          var currentAddonPrice = productOriginalPrice.getAttribute("data-addon-price") ? productOriginalPrice.getAttribute("data-addon-price") : 0;
          var currentTotalPrice = productOriginalPrice.getAttribute("data-current-price") ? productOriginalPrice.getAttribute("data-current-price") : orginalPrice;
          var updatedAddonPrice = parseInt(currentAddonPrice) + parseInt(price);
          var variantPrice = productOriginalPrice.getAttribute("data-price");
          var totalPrice = updatedAddonPrice + parseInt(variantPrice)
          var formattedPrice = Shopify.formatMoney(totalPrice, productBottomSettings.moneyFormat)

          productOriginalPrice.setAttribute("data-addon-price", parseInt(currentAddonPrice) + parseInt(price))
          productOriginalPrice.setAttribute("data-current-price", parseInt(currentTotalPrice) + parseInt(price))
          productOriginalPrice.innerHTML = formattedPrice

          if (parentProdOnSale) {

            var currentAddonPrice = productSalePrice.getAttribute("data-addon-price") ? productSalePrice.getAttribute("data-addon-price") : 0;
            var currentTotalPrice = productSalePrice.getAttribute("data-current-price") ? productSalePrice.getAttribute("data-current-price") : productPrice;
            var updatedAddonPrice = parseInt(currentAddonPrice) + parseInt(price);
            var variantPrice = productSalePrice.getAttribute("data-price");
            var saleTotalPrice = updatedAddonPrice + parseInt(variantPrice)
            var saleFormattedPrice = Shopify.formatMoney(saleTotalPrice, productBottomSettings.moneyFormat)

            productSalePrice.setAttribute("data-addon-price", parseInt(currentAddonPrice) + parseInt(price))
            productSalePrice.setAttribute("data-current-price", parseInt(currentTotalPrice) + parseInt(price))
            productSalePrice.innerHTML = saleFormattedPrice

            addtocartprice.innerHTML = saleFormattedPrice
            addtocartprice.setAttribute("data-total-price", saleTotalPrice)

          } else {
            addtocartprice.innerHTML = formattedPrice
            addtocartprice.setAttribute("data-total-price", totalPrice)
          }

        } else {
          addOnPrice(selectel, selected, price, priceStrikethrough)
          var currentAddonPrice = productOriginalPrice.getAttribute("data-addon-price") ? productOriginalPrice.getAttribute("data-addon-price") : 0;
          var currentTotalPrice = productOriginalPrice.getAttribute("data-current-price") ? productOriginalPrice.getAttribute("data-current-price") : orginalPrice;
          var updatedAddonPrice = parseInt(currentAddonPrice) - parseInt(price);
          var variantPrice = productOriginalPrice.getAttribute("data-price");
          var totalPrice = updatedAddonPrice + parseInt(variantPrice)
          var formattedPrice = Shopify.formatMoney(totalPrice, productBottomSettings.moneyFormat)

          productOriginalPrice.setAttribute("data-addon-price", parseInt(currentAddonPrice) - parseInt(price))
          productOriginalPrice.setAttribute("data-current-price", parseInt(currentTotalPrice) - parseInt(price))
          productOriginalPrice.innerHTML = formattedPrice

          if (parentProdOnSale) {

            var currentAddonPrice = productSalePrice.getAttribute("data-addon-price") ? productSalePrice.getAttribute("data-addon-price") : 0;
            var currentTotalPrice = productSalePrice.getAttribute("data-current-price") ? productSalePrice.getAttribute("data-current-price") : productPrice;
            var updatedAddonPrice = parseInt(currentAddonPrice) - parseInt(price);
            var variantPrice = productSalePrice.getAttribute("data-price");
            var saleTotalPrice = updatedAddonPrice + parseInt(variantPrice)
            var saleFormattedPrice = Shopify.formatMoney(saleTotalPrice, productBottomSettings.moneyFormat)

            productSalePrice.setAttribute("data-addon-price", parseInt(currentAddonPrice) - parseInt(price))
            productSalePrice.setAttribute("data-current-price", parseInt(currentTotalPrice) - parseInt(price))
            productSalePrice.innerHTML = saleFormattedPrice

            addtocartprice.innerHTML = saleFormattedPrice
            addtocartprice.setAttribute("data-total-price", saleTotalPrice)

          } else {
            addtocartprice.innerHTML = formattedPrice
            addtocartprice.setAttribute("data-total-price", totalPrice)
          }
        }
      });
    })
  }

  var JunoProductAdd = (function (module, $) {
    'use strict';

    // Public functions
    var init;

    // Private general variables
    var settings, firstOptionValue, secondOptionValue, thirdOptionValue, firstOptionPostion, secondOptionPostion, thirdOptionPostion, productVariants = [];

    // Private plugin variables
    var $productForm, $addToCart, $productPrice, $productOptions, $productVariantDetail, $productVariantPrice, $productOption, $selectOption, $preOder, $estimateArrival, $comingSoonBtn, $preOrderBtn, $notifyMeBtn, $selectOptionSize, $elementSelectOption, $firstOption, $secondOption, $thirdOption, $ecoFee, $ecoFeeLineItem;

    // Private functions
    var selectCallback, selectVariant, optionUnavailable, checkOptionOutOfStock;


    init = function (options) {
      settings = {
        productForm: '#addToCartForm',
        addToCart: '#addToCart',
        comingSoonBtn: '#comingSoonButtonPopupTrigger',
        preOrderBtn: '#preOrderButton',
        preOrderPopupBtn: '#preOrderButtonPopupTrigger',
        notifyMeBtn: '#notifyMe',
        productOptions: '#product-select',
        productVariantDetail: '#product-variant-detail',
        productVariantPrice: '.variant-price',
        preOder: '#product-pre-order',
        estimateArrival: '#product-estimated',
        productPrice: '.product-price',
        selectOption: '.select-option',
        firstOption: '.select-option[data-origin-index="1"]',
        secondOption: '.select-option[data-origin-index="2"]',
        thirdOption: '.select-option[data-origin-index="3"]',
        ecoFee: '.js-eco-fee',
        ecoFeeLineItem: '.js-eco-fee-line-item'
      };

      productVariants = productBottomSettings.productVariantsContent;

      $productForm = $(settings.productForm);
      $addToCart = $productForm.find(settings.addToCart);
      $comingSoonBtn = $productForm.find(settings.comingSoonBtn);
      $preOrderBtn = $productForm.find(settings.preOrderBtn);
      $notifyMeBtn = $productForm.find(settings.notifyMeBtn);
      $productPrice = $productForm.find(settings.productPrice);
      $productOptions = $productForm.find(settings.productOptions);
      $productVariantDetail = $productForm.find(settings.productVariantDetail);
      $productVariantPrice = $productForm.find(settings.productVariantPrice);
      $preOder = $productForm.find(settings.preOder);
      $estimateArrival = $productForm.find(settings.estimateArrival);
      $ecoFee = $productForm.find(settings.ecoFee);
      $ecoFeeLineItem = $productForm.find(settings.ecoFeeLineItem);
      $firstOption = $productForm.find(settings.firstOption);
      $secondOption = $productForm.find(settings.secondOption);
      $thirdOption = $productForm.find(settings.thirdOption);
      $selectOption = $productForm.find(settings.selectOption);
      $selectOptionSize = $selectOption.hasClass('addon') === true ? $selectOption.size() - 1 : $selectOption.size();
      $elementSelectOption = $selectOption.find('li');

      let defaultVariantId = window.product.defaultVariantId;

      if (location.search.length && location.search.split('variant=').length > 1) {
        defaultVariantId = new URLSearchParams(location.search).get("variant")
        
        if(defaultVariantId.includes('?')){
          if (defaultVariantId.includes('/?')) {
            defaultVariantId = defaultVariantId.split("/?")[0];
          } else {
            defaultVariantId = defaultVariantId.split("?")[0];
          }
        }

        if($productOptions.find(`[value=${defaultVariantId}]`).length == 0){
          defaultVariantId = window.product.defaultVariantId;
          var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + defaultVariantId;
          window.history.replaceState({
            path: newurl
          }, "", newurl);

        }
      } else {
        const $inStockSiblingLink = $('#inStockSiblingLink');
        if ($inStockSiblingLink.length > 0) {
          let inStockLink = $inStockSiblingLink.data('default').replace('/products/', '');
          if (inStockLink !== '') {
            const inStockID = Object.keys(variantMatches).find(key => variantMatches[key] === inStockLink);
            if (inStockID !== undefined) {
              defaultVariantId = inStockID;
            }
          }
        }
      }



      $productOptions.val(defaultVariantId).change();

      new Shopify.OptionSelectors('product-select', { product: productJson, onVariantSelected: selectCallback, enableHistoryState: false });
      selectVariant();
    };


    selectCallback = function (variant, selector) {

      if (variant) {
        let isNotify = false, isPreOrder = false, isOutOfStock = false, isComingSoon = false, isPreOrderPopup = false, isPriceHide = false;

        let estimate_arrival = null;
        let eco_fee_status = false;
        let eco_fee_value = null;

        $addToCart.show().removeClass('disabled is-soldout is-preorder is-coming-soon is-notify-me').prop('disabled', false);
        $notifyMeBtn.hide();
        $preOrderBtn.hide();
        $comingSoonBtn.hide();
        $estimateArrival.hide();
        $estimateArrival.find('.text').text('');
        $estimateArrival.find('.input').val('');
        $preOder.empty();
        $('.product-price-js').show();
        $('.product-estimated-text-popup').empty();
        $ecoFee.empty();
        $ecoFeeLineItem.empty();

        $selectOption.each(function () {
          var selected = $(this).find('li.selected')
          if (selected.hasClass('out-of-stock')) {
            isOutOfStock = true
          }
        })

        if (productVariants.length > 0) {

          productVariants.forEach(function (item, index) {

            if (item.id == variant.id) {
              $(settings.productForm).find('#product-inventory').find('.input').val(item.inventory_quantity);

              estimate_arrival = item.estimate_arrival;
              eco_fee_status = item.eco_fee_status;
              eco_fee_value = item.eco_fee_value;

              if (item.cta_message == 'pre-order') {
                isPreOrder = true;
              }
              if (item.cta_message == 'notify-me') {
                isNotify = true;
              }
              if (item.cta_message == 'coming-soon') {
                isComingSoon = true;
              }
              if (item.cta_message == 'sold-out') {
                isOutOfStock = true;
              }

              if (item.price_hide == 'true') {
                isPriceHide = true;
              }

              if (item.inventory_quantity <= 0 && item.inventory_policy === 'deny') {
                if (item.cta_message === null && item.inventory_management !== null && !item.limited_edition) {
                  isNotify = true;
                }

                if (item.cta_message === 'add-to-cart' && item.inventory_management !== null) {
                  isNotify = false;
                }
              }

              if (item.inventory_quantity <= 0 && item.inventory_policy === 'deny' && !item.limited_edition) {
                if (item.cta_message == 'pre-order') {
                  isPreOrder = false;
                  isNotify = true;
                } else {
                  isOutOfStock = true
                }
              }

              if (item.inventory_quantity <= 0 && item.inventory_policy === 'continue' && !item.limited_edition) {
                if (item.cta_message === null) {
                  isPreOrder = true;
                }
              }
              if (item.inventory_quantity <= 0 && item.inventory_policy === 'continue' && item.limited_edition) {
                isOutOfStock = true
              }
            }
          });
        }
        if (estimate_arrival !== null) {
          $estimateArrival.show();
          $estimateArrival.find('.text').text(estimate_arrival);
          $estimateArrival.find('.input').val(estimate_arrival);
          $('.product-estimated-text-popup').html(estimate_arrival);
        }
        if (eco_fee_status) {
          $ecoFee.html(eco_fee_value);
          $ecoFeeLineItem.html('<input type="hidden" value="'+eco_fee_value+'" id="properties-eco-fee" name="properties[Eco Fee]" />');
        }
        if (isNotify == true) {
          $addToCart.hide();
          $notifyMeBtn.css('display', 'block');
          updateNotifyMeForm(variant.sku, variant.title);
        }

        if (isPreOrder == true) {
          $addToCart.hide();
          $preOrderBtn.css('display', 'block');
          $preOder.html('<input type="hidden" value="Pre Order" id="properties[preOrder]" name="properties[preOrder]" />');
        }

        if (isComingSoon == true) {
          $addToCart.hide();
          $comingSoonBtn.css('display', 'block');
        }

        if (isOutOfStock == true) {
          $addToCart.addClass('disabled is-soldout').prop('disabled', true);
        } else {
          if ($firstOption.length > 0) {
            firstOptionPostion = $firstOption.data('option');
            firstOptionValue = variant[firstOptionPostion];
          }
          if ($secondOption.length > 0) {
            secondOptionPostion = $secondOption.data('option');
            secondOptionValue = variant[secondOptionPostion];
          }
          if ($thirdOption.length > 0) {
            thirdOptionPostion = $thirdOption.data('option');
            thirdOptionValue = variant[thirdOptionPostion];
          }

          optionUnavailable(null, firstOptionValue, secondOptionValue, thirdOptionValue);
        }


        var checkOptionSelected = 0;
        $selectOption.each(function () {
          $(this).find('li').each(function () {
            if ($(this).hasClass('selected')) {
              let value = $(this).data('value').replace('/', '<span>/</span>'),
                $select_option = $(this).parents('.select-option').eq(0),
                name = $select_option.data('name');

              let valueStr = value.split(' ');
              let addSpanToValueStr = valueStr.map((item) => {
                if (item.length > 10) {
                  return `<span class="word-break-all">${item}</span>`
                }
                else {
                  return `<span>${item}</span>`
                }

              });
              value = addSpanToValueStr.join(' ');

              $select_option.find('.value').html(value.trim());
              $productVariantDetail.find('li.' + name + ' .value').html(value.trim());
              checkOptionSelected += 1;
            }
          });
        });

        if (isPriceHide == true) {
          $('.product-price-js').hide();
        }

        if ($selectOptionSize == checkOptionSelected) {
          updatePrices(variant);
        }

        checkForMatchingProducts();

      } else {
        $productForm.addClass('disabled').prop('disabled', true);
      }
    };

    selectVariant = function () {

      $elementSelectOption.on('click', function (e) {
        e.preventDefault();

        var $this = $(this), $thisValue, $thisSelectOption, $thisOptionSelector, $thisOptionPosition, $thisOptionIndex, $option, $optionValue;
        var addonPriceElements = document.querySelectorAll('.c-addon__details--price')

        $('#product-variants').find('li').removeClass('selected')
        $('.select-option').find('li').removeClass('unavailable').removeClass('hide')

        if ($this.hasClass('unavailable') || $this.hasClass('out-of-stock')) {
          $('#toggle-unavailable-modal').trigger('click');
        }

        if ($this.hasClass('selected')) {
          return;
        }

        $thisValue = $this.data('value');
        $thisSelectOption = $this.parents(settings.selectOption).eq(0);
        $thisOptionSelector = $($thisSelectOption.data('select-option'));
        $thisOptionIndex = $thisSelectOption.index() + 1;

        if ($firstOption && $firstOption.find('li.selected').data('value') != undefined) {
          firstOptionValue = $firstOption.find('li.selected').data('value');
        }

        if ($secondOption && $secondOption.find('li.selected').data('value') != undefined) {
          secondOptionValue = $secondOption.find('li.selected').data('value');
        }

        if ($thirdOption && $thirdOption.find('li.selected').data('value') != undefined) {
          thirdOptionValue = $thirdOption.find('li.selected').data('value');
        }

        switch ($thisOptionIndex) {
          case 1:
            firstOptionValue = $thisValue;
            break;
          case 2:
            secondOptionValue = $thisValue;
            break;
          case 3:
            thirdOptionValue = $thisValue;
            break;
        }

        $this.addClass('selected');
        $thisSelectOption.find('li').not($this).removeClass('selected');
        $thisOptionSelector.val($thisValue).change();
        optionUnavailable($this, firstOptionValue, secondOptionValue, thirdOptionValue);
        updatevariantSKU();
        updateBadges();
        updateImages();

        var activeVariant = $('#product-select').val();
        var activeVariantSku = $('#product-select').find(":selected").attr("data-sku");

        $(".js-item-number").html(activeVariantSku)

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + activeVariant;
        window.history.replaceState({ path: newurl }, '', newurl);

        var currentConfigObject = productBottomSettings.variantAddons.find(x => x.id == activeVariant);

        updateAddons(currentConfigObject);
      });
    }

    optionUnavailable = function ($this, firstOptionValue, secondOptionValue, thirdOptionValue) {
      var $dataFirstOptionValue, $dataSecondOptionValue, $dataThirdOptionValue, $dataInventoryQuantity, $dataVariantID, $optionOutOfStock, $thisSelectOption, $thisOptionIndex;

      if ($this != null) {
        $thisSelectOption = $this.parents(settings.selectOption).eq(0);
        $thisOptionIndex = $thisSelectOption.index() + 1;
      }

      //First Option
      if ($firstOption.length > 0) {
        firstOptionPostion = $firstOption.data('option');
      }
      //Second Option
      if ($secondOption.length > 0) {
        secondOptionPostion = $secondOption.data('option');
      }
      //Third Option
      if ($thirdOption.length > 0) {
        thirdOptionPostion = $thirdOption.data('option');
      }
      //Out of Stock
      if ($firstOption.length > 0) {
        if (firstOptionValue != null) {
          if ($thisOptionIndex == 1) {
            if ($secondOption.length > 0 && $thirdOption.length == 0) {
              $secondOption.find('li').removeClass('out-of-stock unavailable hide');
            }
            if ($secondOption.length > 0 && $thirdOption.length > 0) {
              $secondOption.find('li').removeClass('out-of-stock unavailable hide');
              $thirdOption.find('li').removeClass('out-of-stock unavailable hide');
            }
          }

          if ($thisOptionIndex == 2) {
            $firstOption.find('li').removeClass('out-of-stock unavailable hide');
            if ($thirdOption.length > 0) {
              $thirdOption.find('li').removeClass('out-of-stock unavailable hide');
            }
          }

          if ($thisOptionIndex == 3) {
            $firstOption.find('li').removeClass('out-of-stock unavailable hide');
            $secondOption.find('li').removeClass('out-of-stock unavailable hide');
          }

          $firstOption.find('li[data-value="' + firstOptionValue + '"]').addClass('selected');
          // One Option
          if ($secondOption.length == 0 && $thirdOption.length == 0) {
            var $firstOptionValues = [], $firstOptionAvailableValues = [], $firstOptionUnavailableValues = [];

            $firstOption.find('li').removeClass('out-of-stock unavailable hide').each(function () {
              $firstOptionValues.push($(this).data('value'));
            });

            $productOptions.find('option').each(function () {
              $dataFirstOptionValue = $(this).data(firstOptionPostion);
              $firstOptionAvailableValues.push($dataFirstOptionValue);
              $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));

              if ($dataInventoryQuantity < 1) {
                $optionOutOfStock = $dataFirstOptionValue;
                $firstOption.find('li').each(function () {
                  if ($(this).data('value') == $optionOutOfStock) {
                    $(this).addClass('out-of-stock').removeClass('selected');
                  }
                });
              }
            });
            checkOptionOutOfStock($firstOption, firstOptionPostion, firstOptionValue, firstOptionPostion);
            $firstOptionUnavailableValues = arrayDiff($firstOptionValues, $firstOptionAvailableValues);
            if ($firstOptionUnavailableValues.length > 0) {
              $firstOptionUnavailableValues.forEach(function (unavailableValue, index) {
                $firstOption.find('li').each(function () {
                  if ($(this).data('value') == unavailableValue) {
                    var $this_unavailable = $(this);
                    $this_unavailable.addClass('unavailable').removeClass('selected');
                    productVariants.forEach(function (item, index) {
                      if (item.option1 == $this_unavailable.data('value') && item.variant_hide == 'true') {
                        $this_unavailable.addClass('hide');
                      }
                    });
                  }
                });
              });
            }
          }
          if ($thirdOption.length == 0) {
            // Two Options
            if ($secondOption.length > 0) {
              var $secondOptionValues = [], $secondOptionAvailableValues = [], $secondOptionUnavailableValues = [],
                $firstOptionValues = [], $firstOptionAvailableValues = [], $firstOptionUnavailableValues = [];
              $secondOption.find('li[data-value="' + secondOptionValue + '"]').addClass('selected');
              $secondOption.find('li').each(function () {
                $secondOptionValues.push($(this).data('value'));
              });
              $firstOption.find('li').each(function () {
                $firstOptionValues.push($(this).data('value'));
              });
              $productOptions.find('option').each(function () {
                $dataFirstOptionValue = $(this).data(firstOptionPostion);
                $dataSecondOptionValue = $(this).data(secondOptionPostion);
                $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));
                //Second
                if ($dataFirstOptionValue == firstOptionValue) {
                  $secondOptionAvailableValues.push($dataSecondOptionValue);
                  if ($dataInventoryQuantity < 1) {
                    $optionOutOfStock = $dataSecondOptionValue;
                    $secondOption.find('li').each(function () {
                      if ($(this).data('value') == $optionOutOfStock) {
                        $(this).addClass('out-of-stock').removeClass('selected');
                      }
                    });
                  }
                }
                //First
                if (secondOptionValue != null) {
                  if ($dataSecondOptionValue == secondOptionValue) {
                    $firstOptionAvailableValues.push($dataFirstOptionValue);
                    if ($dataInventoryQuantity < 1) {
                      $optionOutOfStock = $dataFirstOptionValue;
                      $firstOption.find('li').each(function () {
                        if ($(this).data('value') == $optionOutOfStock) {
                          $(this).addClass('out-of-stock').removeClass('selected');
                        }
                      });
                    }
                  }
                }
              });
              checkOptionOutOfStock($secondOption, secondOptionPostion, firstOptionValue, firstOptionPostion);
              $secondOptionUnavailableValues = arrayDiff($secondOptionValues, $secondOptionAvailableValues);
              if ($secondOptionUnavailableValues.length > 0) {
                $secondOptionUnavailableValues.forEach(function (unavailableValue, index) {
                  $secondOption.find('li').each(function () {
                    if ($(this).data('value') == unavailableValue) {
                      var $this_unavailable = $(this);
                      $this_unavailable.addClass('unavailable').removeClass('selected');
                      productVariants.forEach(function (item, index) {
                        if (item.option1 == firstOptionValue && item.option2 == $this_unavailable.data('value') && item.variant_hide == 'true') {
                          $this_unavailable.addClass('hide');
                        }
                      });
                    }
                  });
                });
              }
              if (secondOptionValue != null) {
                $firstOptionUnavailableValues = arrayDiff($firstOptionValues, $firstOptionAvailableValues);
                if ($firstOptionUnavailableValues.length > 0) {
                  $firstOptionUnavailableValues.forEach(function (unavailableValue, index) {
                    $firstOption.find('li').each(function () {
                      if ($(this).data('value') == unavailableValue) {
                        var $this_unavailable = $(this);
                        $this_unavailable.addClass('unavailable').removeClass('selected');
                        productVariants.forEach(function (item, index) {
                          if (item.option1 == $this_unavailable.data('value') && item.option2 == secondOptionValue && item.variant_hide == 'true') {
                            $this_unavailable.addClass('hide');
                          }
                        });
                      }
                    });
                  });
                }
              }
            }
          } else {
            // Three Options
            //Select Second Option
            if (secondOptionValue != null) {
              var $firstOptionValues = [], $firstOptionAvailableValues = [], $firstOptionUnavailableValues = [],
                $secondOptionValues = [], $secondOptionAvailableValues = [], $secondOptionUnavailableValues = [],
                $thirdOptionValues = [], $thirdOptionAvailableValues = [], $thirdOptionUnavailableValues = [];
              $thirdOption.find('li[data-value="' + thirdOptionValue + '"]').addClass('selected');
              $firstOption.find('li').removeClass('out-of-stock unavailable hide').each(function () {
                $firstOptionValues.push($(this).data('value'));
              });
              $secondOption.find('li').removeClass('out-of-stock unavailable hide').each(function () {
                $secondOptionValues.push($(this).data('value'));
              });
              $thirdOption.find('li').removeClass('out-of-stock unavailable hide').each(function () {
                $thirdOptionValues.push($(this).data('value'));
              });
              $productOptions.find('option').each(function () {
                $dataFirstOptionValue = $(this).data(firstOptionPostion);
                $dataSecondOptionValue = $(this).data(secondOptionPostion);
                $dataThirdOptionValue = $(this).data(thirdOptionPostion);
                $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));

                if ($dataFirstOptionValue == firstOptionValue && $dataSecondOptionValue == secondOptionValue) {
                  $thirdOptionAvailableValues.push($dataThirdOptionValue);
                  if ($dataInventoryQuantity < 1) {
                    $optionOutOfStock = $dataThirdOptionValue;
                    $thirdOption.find('li').each(function () {
                      if ($(this).data('value') == $optionOutOfStock) {
                        $(this).addClass('out-of-stock').removeClass('selected');
                      }
                    });
                  }
                }
                //First
                if ($dataSecondOptionValue == secondOptionValue && $dataThirdOptionValue == thirdOptionValue) {
                  $firstOptionAvailableValues.push($dataFirstOptionValue);
                  if ($dataInventoryQuantity < 1) {
                    $optionOutOfStock = $dataFirstOptionValue;
                    $firstOption.find('li').each(function () {
                      if ($(this).data('value') == $optionOutOfStock) {
                        $(this).addClass('out-of-stock').removeClass('selected');
                      }
                    });
                  }
                }
              });
              checkOptionOutOfStock($thirdOption, thirdOptionPostion, firstOptionValue, firstOptionPostion, secondOptionValue, secondOptionPostion);
              $thirdOptionUnavailableValues = arrayDiff($thirdOptionValues, $thirdOptionAvailableValues);
              if ($thirdOptionUnavailableValues.length > 0) {
                $thirdOptionUnavailableValues.forEach(function (unavailableValue, index) {
                  $thirdOption.find('li').each(function () {
                    if ($(this).data('value') == unavailableValue) {
                      var $this_unavailable = $(this);
                      $this_unavailable.addClass('unavailable').removeClass('selected');
                      productVariants.forEach(function (item, index) {
                        if (item.option1 == firstOptionValue && item.option2 == secondOptionValue && item.option3 == $this_unavailable.data('value') && item.variant_hide == 'true') {
                          $this_unavailable.addClass('hide');
                        }
                      });
                    }
                  });
                });
              }
              $firstOptionUnavailableValues = arrayDiff($firstOptionValues, $firstOptionAvailableValues);
              if ($firstOptionUnavailableValues.length > 0) {
                $firstOptionUnavailableValues.forEach(function (unavailableValue, index) {
                  $firstOption.find('li').each(function () {
                    if ($(this).data('value') == unavailableValue) {
                      var $this_unavailable = $(this);
                      $this_unavailable.addClass('unavailable').removeClass('selected');
                      productVariants.forEach(function (item, index) {
                        if (item.option1 == $this_unavailable.data('value') && item.option2 == secondOptionValue && item.option3 == thirdOptionValue && item.variant_hide == 'true') {
                          $this_unavailable.addClass('hide');
                        }
                      });
                    }
                  });
                });
              }
            }
            //Select Third Option
            if (thirdOptionValue != null) {
              var $firstOptionValues = [], $firstOptionAvailableValues = [], $firstOptionUnavailableValues = [],
                $secondOptionValues = [], $secondOptionAvailableValues = [], $secondOptionUnavailableValues = [],
                $thirdOptionValues = [], $thirdOptionAvailableValues = [], $thirdOptionUnavailableValues = [];
              $secondOption.find('li[data-value="' + secondOptionValue + '"]').addClass('selected');
              $firstOption.find('li').removeClass('out-of-stock unavailable hide').each(function () {
                $firstOptionValues.push($(this).data('value'));
              });
              $secondOption.find('li').removeClass('out-of-stock unavailable hide').each(function () {
                $secondOptionValues.push($(this).data('value'));
              });
              $thirdOption.find('li').removeClass('out-of-stock unavailable hide').each(function () {
                $thirdOptionValues.push($(this).data('value'));
              });
              $productOptions.find('option').each(function () {
                $dataFirstOptionValue = $(this).data(firstOptionPostion);
                $dataSecondOptionValue = $(this).data(secondOptionPostion);
                $dataThirdOptionValue = $(this).data(thirdOptionPostion);
                $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));

                if ($dataFirstOptionValue == firstOptionValue && $dataThirdOptionValue == thirdOptionValue) {
                  $secondOptionAvailableValues.push($dataSecondOptionValue);
                  if ($dataInventoryQuantity < 1) {
                    $optionOutOfStock = $dataSecondOptionValue;
                    $secondOption.find('li').each(function () {
                      if ($(this).data('value') == $optionOutOfStock) {
                        $(this).addClass('out-of-stock').removeClass('selected');
                      }
                    });
                  }
                }



                //First
                if ($dataSecondOptionValue == secondOptionValue && $dataThirdOptionValue == thirdOptionValue) {
                  $firstOptionAvailableValues.push($dataFirstOptionValue);
                  if ($dataInventoryQuantity < 1) {
                    $optionOutOfStock = $dataFirstOptionValue;
                    $firstOption.find('li').each(function () {
                      if ($(this).data('value') == $optionOutOfStock) {
                        $(this).addClass('out-of-stock').removeClass('selected');
                      }
                    });
                  }
                }

                //Third
                if ($dataFirstOptionValue == firstOptionValue && $dataSecondOptionValue == secondOptionValue) {
                  $thirdOptionAvailableValues.push($dataThirdOptionValue);
                  if ($dataInventoryQuantity < 1) {
                    $optionOutOfStock = $dataThirdOptionValue;
                    $thirdOption.find('li').each(function () {
                      if ($(this).data('value') == $optionOutOfStock) {
                        $(this).addClass('out-of-stock').removeClass('selected');
                      }
                    });
                  }
                }
              });
              checkOptionOutOfStock($secondOption, secondOptionPostion, firstOptionValue, firstOptionPostion, thirdOptionValue, thirdOptionPostion);
              $secondOptionUnavailableValues = arrayDiff($secondOptionValues, $secondOptionAvailableValues);
              if ($secondOptionUnavailableValues.length > 0) {
                $secondOptionUnavailableValues.forEach(function (unavailableValue, index) {
                  $secondOption.find('li').each(function () {
                    if ($(this).data('value') == unavailableValue) {
                      var $this_unavailable = $(this);
                      $this_unavailable.addClass('unavailable').removeClass('selected');
                      productVariants.forEach(function (item, index) {
                        if (item.option1 == firstOptionValue && item.option2 == $this_unavailable.data('value') && item.option3 == thirdOptionValue && item.variant_hide == 'true') {
                          $this_unavailable.addClass('hide');
                        }
                      });
                    }
                  });
                });
              }
              $firstOptionUnavailableValues = arrayDiff($firstOptionValues, $firstOptionAvailableValues);
              if ($firstOptionUnavailableValues.length > 0) {
                $firstOptionUnavailableValues.forEach(function (unavailableValue, index) {
                  $firstOption.find('li').each(function () {
                    if ($(this).data('value') == unavailableValue) {
                      var $this_unavailable = $(this);
                      $this_unavailable.addClass('unavailable').removeClass('selected');
                      productVariants.forEach(function (item, index) {
                        if (item.option1 == $this_unavailable.data('value') && item.option2 == secondOptionValue && item.option3 == thirdOptionValue && item.variant_hide == 'true') {
                          $this_unavailable.addClass('hide');
                        }
                      });
                    }
                  });
                });
              }
            }
          }
        }
      }
    };


    checkOptionOutOfStock = function ($option, optionPosition, selectFirstOptionValue, selectFirstOptionPosition, selectSecondOptionValue, selectSecondOptionPosition) {
      var $dataInventoryQuantity, $optionOutOfStock;
      $.getJSON('/cart.js', function (cart) {
        jQuery.each(cart.items, function (index, item) {
          productVariants.forEach(function (variant, index) {
            if (item.id == variant.id) {
              if (selectFirstOptionValue != null && selectFirstOptionPosition != null) {
                if (selectSecondOptionValue == null && selectSecondOptionPosition == null) {
                  if (variant[selectFirstOptionPosition] == selectFirstOptionValue) {
                    $dataInventoryQuantity = variant.inventory_quantity - parseInt(item.quantity);
                    if ($dataInventoryQuantity < 1) {
                      $optionOutOfStock = variant[optionPosition];
                      $option.find('li').each(function () {
                        if ($(this).data('value') == $optionOutOfStock) {
                          $(this).removeClass('selected').addClass('out-of-stock');
                        }
                      });
                    }
                  }
                } else {
                  if (variant[selectFirstOptionPosition] == selectFirstOptionValue && variant[selectSecondOptionPosition] == selectSecondOptionValue) {
                    $dataInventoryQuantity = variant.inventory_quantity - parseInt(item.quantity);
                    if ($dataInventoryQuantity < 1) {
                      $optionOutOfStock = variant[optionPosition];
                      $option.find('li').each(function () {
                        if ($(this).data('value') == $optionOutOfStock) {
                          $(this).removeClass('selected').addClass('out-of-stock');
                          $(this).attr('data-selected', 'unselected')
                          $addToCart.addClass('disabled is-soldout').prop('disabled', true);
                        }
                      });
                    }
                  }
                }
              }
            }
          });
        });
      });
    };

    module = {
      init: init
    };
    return module;
  }(JunoProductAdd || {}, jQuery));

  jQuery(document).ready(function () {
    JunoProductAdd.init();
    addOnChecks();
    updateBadges();

    var $backHeight = jQuery('.custom.back-height');

    if ($backHeight.length > 0) {
      var name = $backHeight.find('> .title'),
        backHeightName = name.text().trim();
      value = $backHeight.find('.buttons .active').text().trim(),
        bhHTML = '<li class="back-height"><strong>' + backHeightName + ': </strong><span class="value">' + value + '</span></li>';
      bhHTML += ' <input type="hidden" value="' + value + '" id="properties-' + backHeightName + '" name="properties[' + backHeightName + ']" />';

      if (jQuery('#product-variant-detail ul li').last().hasClass('last')) {
        jQuery(bhHTML).insertBefore('#product-variant-detail ul li.last');
      } else if (jQuery('#product-variant-detail ul li.additional').length > 0) {
        jQuery(bhHTML).insertBefore('#product-variant-detail ul li:eq(0)');
      } else {
        jQuery('#product-variant-detail ul').append(bhHTML);
      }

      name = name.data('value').replace('/', '<span>/</span>');

      var nameStr = name.split(' ');
      var addSpanToNameStr = nameStr.map((item) => {
        if (item.length > 10) {
          return `<span class="word-break-all">${item}</span>`
        }
        else {
          return `<span>${item}</span>`
        }
      });
      name = addSpanToNameStr.join(' ');
      $backHeight.find('.value').html(name.trim());
    }

    jQuery('.product-configuration.customisable-config .custom.back-height .title').on('click', function (e) {
      e.preventDefault();
      jQuery(this).parent().toggleClass('active').find('.buttons').slideToggle();
      jQuery(this).parent().attr('aria-expanded', jQuery(this).parent().hasClass('active'));
    });

    if (jQuery('.product-configuration').hasClass('customisable-config')) {
      jQuery('.select-option .label').on('click', function (e) {
        e.preventDefault();
        jQuery(this).parent().toggleClass('active').find('.options').slideToggle();
        jQuery(this).attr('aria-expanded', jQuery(this).parent().hasClass('active'));
      });
    }

    jQuery('.select-option .tooltip').on('click', function (e) {
      e.preventDefault();
      jQuery(this).parents('.select-option').eq(0).toggleClass('tooltip-active');
    });


    jQuery(document.body).on('afterCartLoad.ajaxCart', function (evt, cart) {
      resetAddons();
    });
    updateImages();
  });
}
